<template>
  <YaTePrivacypolicy />
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import YaTePrivacypolicy from '~/components/YaTe/YaTePrivacypolicy/YaTePrivacypolicy.vue'

const options = {
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',
    })
    return {
      title:
        'LINEヤフーテックアカデミープライバシーポリシー | テックアカデミー',
      meta: [
        ...metaTags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            description: 'LINEヤフーテックアカデミーのプライバシーポリシー',
            twitterTitle:
              'LINEヤフーテックアカデミープライバシーポリシー | テックアカデミー',
            twitterDescription:
              'LINEヤフーテックアカデミーのプライバシーポリシー',
            twitterImage: '/_nuxt/ogp/yate/og-image.jpg',
            ogDescription: 'LINEヤフーテックアカデミーのプライバシーポリシー',
            ogTitle:
              'LINEヤフーテックアカデミープライバシーポリシー | テックアカデミー',
            ogUrl: '/yahoo/privacypolicy',
            ogImage: '/_nuxt/ogp/yate/og-image.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    YaTePrivacypolicy,
  },
  async setup() {
    definePageMeta({
      layout: 'yate-side-menu'
    })
  },
}

export default defineNuxtComponent(options)
</script>
